import { render, staticRenderFns } from "./SettingsCurrency.vue?vue&type=template&id=83505b92&scoped=true"
import script from "./SettingsCurrency.vue?vue&type=script&lang=js"
export * from "./SettingsCurrency.vue?vue&type=script&lang=js"
import style0 from "./SettingsCurrency.vue?vue&type=style&index=0&id=83505b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83505b92",
  null
  
)

export default component.exports